'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespaceCompat(e) {
    if (e && typeof e === 'object' && 'default' in e) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceCompat(React);

const Svg16 = (props) => (React__namespace.createElement("svg", Object.assign({ width: 16, height: 16, viewBox: "0 0 16 16", fill: "none" }, props),
    React__namespace.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.902 2a.81.81 0 0 0-.712.427l-.26.488H2.7a.7.7 0 1 0 0 1.4h10.708a.7.7 0 1 0 0-1.4h-3.41l-.152-.396a.81.81 0 0 0-.754-.52z", fill: props.fillColor, fillOpacity: 0.92 }),
    React__namespace.createElement("path", { d: "m3.809 5.823.681 5.84a1.615 1.615 0 0 0 1.604 1.428h3.913c.803 0 1.484-.59 1.598-1.384l.851-5.884M6.854 7.034v3.23m2.423-3.23v3.23", stroke: props.strokeColor, strokeOpacity: 0.92, strokeWidth: 1.4, strokeLinecap: "round" })));

exports.default = Svg16;
//# sourceMappingURL=16.js.map
